import React, { Component } from "react";
import logo from "./assets/icontransparent.png";

export default class Navbar extends Component {
  render() {
    return (
      <nav className="navbar" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <a className="navbar-item" href="/">
            <img
              style={{ width: 50, height: 50, maxHeight: 50 }}
              className="logo"
              src={logo}
            ></img>
          </a>
        </div>
        <div id="navbarBasicExample" className="navbar-menu">
          <div className="navbar-start">
            <a href="/dashboard" className="navbar-item">
              Dashboard
            </a>
            {this.props.auth.user.admin && (
              <>
                <a href="/kampagner" className="navbar-item">
                  Kampagner
                </a>
                <a href="/challenges" className="navbar-item">
                  Challenges
                </a>
                <a href="/virksomheder" className="navbar-item">
                  Virksomheder
                </a>
                <a href="/hold" className="navbar-item">
                  Hold
                </a>
                <a href="/ligaer" className="navbar-item">
                  Ligaer
                </a>
                <a href="/aktiviteter" className="navbar-item">
                  Aktiviteter
                </a>

                <a href="/quiz" className="navbar-item">
                  Quiz
                </a>

                <a href="/kogebog" className="navbar-item">
                  Kogebog
                </a>

                <a href="/billeder" className="navbar-item">
                  Billeder
                </a>

                <a href="/notifikation" className="navbar-item">
                  Notifikation
                </a>

                <a href="/messageboard" className="navbar-item">
                  Beskedbræt
                </a>
                <a href="/brugere" className="navbar-item">
                  Brugere
                </a>
                <a href="/stats" className="navbar-item">
                  Statistik
                </a>
                <a href="/anmeldelser" className="navbar-item">
                  Anmeldelser
                </a>
                <a href="/modifypoints" className="navbar-item">
                  Modificer Points
                </a>
              </>
            )}
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              {this.props.auth.checkAuth() ? (
                <div className="buttons">
                  <p>Du er logget ind: {this.props.auth.user.username}</p>
                  <a
                    href="/"
                    onClick={this.props.auth.handleLogout}
                    className="button is-danger"
                  >
                    <strong>Log out</strong>
                  </a>
                </div>
              ) : (
                <div className="buttons">
                  <a href="/login" className="button is-light">
                    Log in
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    );
  }
}
